import { Box } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import { ResizableBox } from "react-resizable";

import { MaybeNull } from "types";

import { RecPdfDocument, RecPdfEmptyData, RecPdfPagination } from "./components";
import {
  REC_PDF_DOCUMENT_DEFAULT_WIDTH,
} from "./consts";
import "./css/style.css";

interface PdfPreviewProps {
  downloadUrl: MaybeNull<string>;
  scale: number;
  isScaleChange: boolean;
  isFileUploaded: any
}

export const RecPdfPreview: FunctionComponent<PdfPreviewProps> = ({
  downloadUrl,
  scale,
  isScaleChange,
  isFileUploaded
}) => {
  const [numberOfPages, setNumberOfPages] = useState<null | number>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [resizeWidth, setResizeWidth] = useState(REC_PDF_DOCUMENT_DEFAULT_WIDTH);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const file = downloadUrl;


  const onLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumberOfPages(numPages);
    setPageNumber(1);
    setIsLoading(false);
  };

  const onPageChange = (newPageNumber: number) => {
    setPageNumber(newPageNumber);
  };
  const onResize = (_: any, { size }: any) => {
    setResizeWidth(size.width);
  };

  const handleFileUploaded = (e: any) => {
   isFileUploaded(e)
  }

  return (
    <ResizableBox
      height={windowHeight - 180}
      width={resizeWidth}
      onResize={onResize}
      minConstraints={[REC_PDF_DOCUMENT_DEFAULT_WIDTH, (windowHeight)]}
      maxConstraints={[900, (windowHeight)]}
      resizeHandles={["e"]}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: 2,
          mr: 5,
          minWidth: REC_PDF_DOCUMENT_DEFAULT_WIDTH,
          position: "relative",
          overflow: "auto", 
          height: "100%",
          justifyContent: !file ? "center" : "flex-start",
        }}
      >
        {!file ? (
          <RecPdfEmptyData isFileUploaded={handleFileUploaded}/>
        ) : (
          <>
            <RecPdfDocument
              width={resizeWidth}
              scale={scale}
              file={file}
              onLoadSuccess={onLoadSuccess}
              pageNumber={pageNumber}
              isScaleChange={isScaleChange}
            />

            {!isLoading && (
              <RecPdfPagination
                pageNumber={pageNumber}
                numberOfPages={numberOfPages}
                onPageChange={onPageChange}
              />
            )}
          </>
        )}
      </Box>
    </ResizableBox>
  );
};
